export default function HealthCareTech() {
  return (
    <div>
      <h1>Health Care Tech Page</h1>
    </div>
  );
}